const glossary = {
	'button.default_text': 'Смотреть в 3D',

    'widget.note_use': 'Введите размеры и нажмите кнопку "Примерить"',
	'widget.title_size': 'Примерка габаритов товара',
	'widget.title_model': 'Примерка товара',
	'widget.depth': 'Длина',
	'widget.width': 'Ширина',
	'widget.height': 'Высота',
	'widget.try': 'Примерить',
	'widget.btn_copy': 'Скопировать ссылку',
	'widget.btn_copy_2': 'Скопировано',
	'widget.share_text': 'Для примерки габаритов товара используйте QR-код на телефоне' +
		' или скопируйте ссылку.',
	'widget.unsupported_text': 'Функция "Просмотр в AR" не работает на вашем устройстве, ' +
		'воспользуйтесь телефоном с операционной системой Андроид 8.0+ и поддержкой ARCore 1.9+.',

	'unit.mm': 'мм',
	'unit.cm': 'см',
	'unit.m': 'м',

	'error.not_loaded': 'Не удалось выполнить загрузку. Повторите попытку позже.',
};

export default () => glossary;